import SSP from './SSP'

export default SSP